// Report.js
import React from "react"

import {
    Document,
    Page,
    Text,
    View,
    StyleSheet,
} from "@react-pdf/renderer"
import {
    funGetDateTime,
    getDateFn,
    getDateTimeFn,
    getItemQty,

} from "./ReportUtility"

const border_color = "gray"
const bg_color = "#dadada"

const styles = StyleSheet.create({
    page: {
        flexDirection: "row",
        backgroundColor: "#ffffff",
    },
    section: {
        margin: 10,
        padding: 0,
        border: "1px",
        flexGrow: 1,
        fontSize: "9px",
        fontFamily: "Helvetica"
    },
    d_header: {
        fontSize: "10px",
        padding: "3px",
        textAlign: "center",
    },
    t_comptitle: {
        fontSize: "14px",
        textAlign: "center",
        textTransform: "uppercase",
        fontWeight: "bold",
        padding: "5px",
    },
    mainflexdiv: {
        border: "1px",
        borderColor: border_color,
        width: "50%",
        padding: "5px 2px",
    },
    dflex_title: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
        alignItems: "top",
        gap: 50
    },

    dflex: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "top",

    },
    t_withbg: {
        backgroundColor: bg_color,
        color: "black",
        padding: "5px",
        paddingTop: "10px"
    },

    title_size: {
        width: "100%",
        textAlign: "right",
    },

    dtotal: {
        backgroundColor: bg_color,
        padding: " 4px 0px",
        borderRadius: "5px",
        textAlign: "center",
        border: "1px solid black",
        margin: "5px  0px ",
        fontFamily: "Helvetica-Bold",
    },

    srno: {
        width: "5%",
        borderRight: "1px",
        marginLeft: "2px",
    },
    desc: {
        width: "80%",
        borderRight: "1px",
    },

    qty: {
        width: "10%",
        borderRight: "1px",
    },
    mrp: {
        width: "13%",
        borderRight: "1px",
    },
    discper: {
        width: "12%",
        borderRight: "1px",
    },
    discamt: {
        width: "15%",
        borderRight: "1px",
    },
    amount: {
        width: "18%",
    },
    bill_title: {
        fontFamily: "Helvetica-Bold",
        textAlign: "center",
    },
    table: {
        display: 'table',
        width: '100%',
    },
    tableRow: {
        margin: 'auto',
        flexDirection: 'row',
        width: '100%'
    },
    tableCol: {
        width: '100%',
        padding: "3px 0px"

    },
    tableCell: {

        // textAlign: "right"
    },
    first_colWidth: {
        width: "50%"
    },
    second_colWidth: {
        width: "45%",
    },
    middle_colWidth: {
        width: "5%"
    },
    font_bold: {
        fontFamily: "Helvetica-Bold"
    },
    box2_first_colWidth: {
        width: "20%",
        paddingLeft: "3px"
    },
    box2_second_colWidth: {
        width: "80%",
        fontSize: "8px",

    },

    tableColItem: {
        fontSize: "9px",
        paddingTop: "3px",

    },
    tableCellItem: {
        textAlign: "center",
        padding: "3px",
    },
    colBorder: { borderRight: "1px", borderBottom: "1px solid #ebeaeb" },
    gstBoxRow: {
        borderBottom: "1px solid gray",
        padding: "1px 5px"
    },

    title_amt: {
        textAlign: "right"
    },
    border_dash: {
        borderBottom: "1px dashed gray",
        padding: "1px 5px"
    },
    row_data: {
        fontSize: "8px"
    },
    pd: {
        padding: "0px 15 0px 5px"
    }
    ,
    font_size: {
        fontSize: "8px"
    }
})

// Create PDF component
const chunkArray = (arr, size = 35) => {
    const chunks = [];

    for (let i = 0; i < arr.length; i += size) {
        chunks.push(arr.slice(i, i + size));
    }

    return chunks;
};
const RptPurchaseOrder = ({ detail, isdistributor }) => {
    let totalQty = 0
    let totalPcs = 0
    let totalAmt = 0
    //let totalAmtBeforetax=0
    let totalInvAmt = 0
    let item = {}
    let itemQty = 0;
    //console.log(detail, "ord")
    const PageSize = 30
    const pages = chunkArray(detail, PageSize);
    if (detail && detail?.length > 0)
        item = detail[0] // detail.filter((val, ind) => ind === 0) //
    const fromDetails =  
         {
            title: "From",
            name: item?.PAc_Desc,
            address: `${item?.PAdd_1 || ""} ${item?.PAdd_2 || ""} ${item?.PAdd_3 || ""} ${item?.PAdd_4 || ""}`,
            pan: item?.Party_PAN,
            gst: item?.Party_GST_No,
        }
        // : {
        //     title: "From",
        //     name: item?.compname,
        //     address: `${item?.comp_add1 || ""} ${item?.comp_add2 || ""} ${item?.comp_add3 || ""} ${item?.comp_add4 || ""}`,
        //     pan: item?.PAN_No,
        //     gst: item?.Comp_GST_No,
        // };

    const toDetails =  
         {
            title: "TO",
            name: item?.compname,
            address: `${item?.comp_add1 || ""} ${item?.comp_add2 || ""} ${item?.comp_add3 || ""} ${item?.comp_add4 || ""}`,
            pan: item?.PAN_No,
            gst: item?.Comp_GST_No,
        }
        // : {
        //     title: "TO",
        //     name: item?.PAc_Desc,
        //     address: `${item?.PAdd_1 || ""} ${item?.PAdd_2 || ""} ${item?.PAdd_3 || ""} ${item?.PAdd_4 || ""}`,
        //     pan: item?.Party_PAN,
        //     gst: item?.Party_GST_No,
        // };
    return (
        <Document pageMode="fullScreen">
            {pages.map((pageRecords, pageIndex) => (
                <Page size="A4" style={styles.page}>
                    <View style={styles.section}>
                        {/* HEader */}

                        <View>
                            {pageIndex == 0 && (
                                <View>
                                    <div style={styles.d_header}>
                                        <div>
                                            <Text style={styles.t_comptitle}>{isdistributor ? "Purchase Order" : "Sale Order"}</Text>
                                        </div>
                                    </div>
                                    {/* <div style={styles.d_header}>
                                        <div>
                                            <Text style={styles.t_comptitle}>{item.PAc_Desc}</Text>
                                        </div>
                                        <div>
                                            <Text>
                                                {item.PAdd_1 +
                                                    " " +
                                                    item.PAdd_2 +
                                                    " " +
                                                    item.PAdd_3 +
                                                    " " +
                                                    item.PAdd_4}
                                            </Text>
                                        </div>
                                        <div>
                                            <div>
                                                <Text>
                                                    Contact No :
                                                    {item.Party_ContectNo1 + " , " + item.Party_ContectNo2}
                                                    <Text style={{ marginLeft: "5px" }}>
                                                        {item.comp_email_id != ""
                                                            ? " Email:" + item.Party_Mail_Desc
                                                            : ""}
                                                    </Text>
                                                </Text>
                                            </div>
                                        </div>
                                        <div style={[styles.dflex, styles.font_bold]}>
                                            <Text>PAN No :{item.Party_PAN}</Text>
                                            <Text>GST No :{item.Party_GST_No}</Text>
                                        </div>
                                    </div> */}
                                    {/* end header */}
                                    {/* Invoice */}
                                    {/* <div style={styles.t_withbg}>
                                        <div style={styles.dflex_title}>
                                            <div style={styles.font_bold}>
                                                <Text>   </Text>
                                            </div>
                                            <div style={[styles.font_bold, { textAlign: "center", fontSize: "10px", paddingLeft: "20px" }]}>
                                                <Text>PURCHASE ORDER </Text>
                                            </div>
                                            <div>
                                                <Text>
                                                    <Text
                                                        style={{ backgroundColor: "#fff", padding: "5px" }}
                                                    ></Text>
                                                    ____Original ____Duplicate ____Triplicate
                                                </Text>
                                            </div>
                                        </div>
                                    </div> */}
                                </View>
                            )}
                            <View style={[styles.table, { backgroundColor: "#ebebeb", padding: "5px", fontSize: "12px" }]}>
                                <View style={[styles.tableRow]}>
                                    <View style={[styles.tableCol, styles.box2_first_colWidth, styles.font_bold, { width: "30%" }]}>
                                        <Text style={[styles.tableCell, styles.font_bold]}>Order Date.</Text>
                                    </View>
                                    <View style={[styles.tableCol, styles.middle_colWidth, styles.font_bold]}>
                                        <Text style={styles.tableCell}> :</Text>
                                    </View>
                                    <View style={[styles.tableCol, styles.box2_second_colWidth, styles.font_bold, { fontSize: "12px" }]}>
                                        <Text style={styles.tableCell}>{getDateFn(item?.Ord_Date)}</Text>
                                    </View>
                                    <View style={[styles.tableCol, styles.box2_first_colWidth, styles.font_bold, { width: "25%" }]}>
                                        <Text style={[styles.tableCell, styles.font_bold]}>Order No.</Text>
                                    </View>
                                    <View style={[styles.tableCol, styles.middle_colWidth, styles.font_bold]}>
                                        <Text style={styles.tableCell}> :</Text>
                                    </View>
                                    <View style={[styles.tableCol, styles.box2_second_colWidth, styles.font_bold, { fontSize: "12px" }]}>
                                        <Text style={styles.tableCell}>{item?.Ord_No}</Text>
                                    </View>

                                </View>
                            </View>
                            <View style={styles.table}>
                                <View style={styles.tableRow}>
                                    {[fromDetails, toDetails].map((details, index) => (
                                        <View
                                            key={index}
                                            style={[styles.tableCol, styles.mainflexdiv]}
                                        >
                                            <View style={styles.table}>
                                                <View style={styles.tableRow}>
                                                    <View style={[styles.tableCol, styles.box2_first_colWidth]}>
                                                        <Text style={[styles.font_bold]}>
                                                            {details.title}
                                                        </Text>
                                                    </View>

                                                    <View style={[styles.tableCol, styles.middle_colWidth]}>
                                                        <Text>:</Text>
                                                    </View>

                                                    <View style={[styles.tableCol, styles.box2_second_colWidth]}>
                                                        <Text style={[styles.font_bold, { lineHeight: 0.6 }]}>
                                                            {details.name}
                                                        </Text>

                                                        <Text style={{ lineHeight: 0.6 }} >{details.address}</Text>
                                                    </View>
                                                </View>

                                                {details.pan && (
                                                    <View style={styles.tableRow}>
                                                        <View style={[styles.tableCol, styles.box2_first_colWidth]}>
                                                            <Text style={styles.font_bold}>Pan No.</Text>
                                                        </View>

                                                        <View style={[styles.tableCol, styles.middle_colWidth]}>
                                                            <Text>:</Text>
                                                        </View>

                                                        <View style={[styles.tableCol, styles.box2_second_colWidth]}>
                                                            <Text>{details.pan}</Text>
                                                        </View>
                                                    </View>
                                                )}

                                                {details.gst && (
                                                    <View style={styles.tableRow}>
                                                        <View style={[styles.tableCol, styles.box2_first_colWidth]}>
                                                            <Text style={styles.font_bold}>Party GST</Text>
                                                        </View>

                                                        <View style={[styles.tableCol, styles.middle_colWidth]}>
                                                            <Text>:</Text>
                                                        </View>

                                                        <View style={[styles.tableCol, styles.box2_second_colWidth]}>
                                                            <Text>{details.gst}</Text>
                                                        </View>
                                                    </View>
                                                )}
                                            </View>
                                        </View>
                                    ))}
                                </View>
                            </View>
                            {/* /end invoice */}
                        </View>

                        {/* Main section */}

                        <View style={[styles.table]}>
                            <View style={[styles.tableRow, styles.font_bold, { borderBottom: "1px" }]}>
                                <View style={[styles.tableColItem, styles.srno, styles.colBorder]}>
                                    <Text style={[styles.tableCellItem]}>No</Text>
                                </View>
                                <View style={[styles.tableColItem, styles.desc, styles.colBorder]}>
                                    <Text style={[styles.tableCellItem]}>Product</Text>
                                </View>

                                <View style={[styles.tableColItem, styles.qty, styles.colBorder]}>
                                    <Text style={[styles.tableCellItem]}>Qty.</Text>
                                </View>
                                <View style={[styles.tableColItem, styles.mrp, styles.colBorder]}>
                                    <Text style={[styles.tableCellItem]}>MRP</Text>
                                </View>
                                <View style={[styles.tableColItem, styles.amount, styles.colBorder]}>
                                    <Text style={[styles.tableCellItem]}>Amount</Text>
                                </View>
                                <View style={[styles.tableColItem, styles.discper, styles.colBorder]}>
                                    <Text style={[styles.tableCellItem]}>Disc%</Text>
                                </View>
                                <View style={[styles.tableColItem, styles.discamt, styles.colBorder]}>
                                    <Text style={[styles.tableCellItem]}>Disc Amt</Text>
                                </View>
                                <View style={[styles.tableColItem, styles.amount, styles.colBorder]}>
                                    <Text style={[styles.tableCellItem]}>Net Amount</Text>
                                </View>

                            </View>
                        </View>

                        <div style={{ minHeight: "5px" }}>


                            <View style={styles.table}>
                                {pageRecords.map((itemlist, inx) => {
                                    totalQty += getItemQty(
                                        itemlist?.Item_Unit,
                                        itemlist?.D_Meter,
                                        itemlist?.D_Pcs,
                                        itemlist?.D_Weight
                                    );

                                    totalPcs += Number(itemlist?.D_Pcs || 0);
                                    totalAmt += Number(itemlist?.NetAmount || 0);

                                    itemQty = getItemQty(
                                        itemlist?.Item_Unit,
                                        itemlist?.D_Meter,
                                        itemlist?.D_Pcs,
                                        itemlist?.D_Weight
                                    );

                                    return (
                                        <View
                                            key={pageIndex * PageSize + inx}
                                            style={styles.tableRow}
                                        >
                                            <View
                                                style={[
                                                    styles.tableColItem,
                                                    styles.srno,
                                                    styles.colBorder,
                                                ]}
                                            >
                                                <Text
                                                    style={[
                                                        styles.tableCellItem,
                                                        styles.row_data,
                                                    ]}
                                                >
                                                    {pageIndex * PageSize + inx + 1}
                                                </Text>
                                            </View>

                                            <View
                                                style={[
                                                    styles.tableColItem,
                                                    styles.desc,
                                                    styles.colBorder,
                                                ]}
                                            >
                                                <Text style={[styles.tableCellItem, styles.row_data, { textAlign: "left" }]}>
                                                    {itemlist?.Item_Desc}
                                                </Text>
                                            </View>

                                            <View
                                                style={[
                                                    styles.tableColItem,
                                                    styles.qty,
                                                    styles.colBorder,
                                                ]}
                                            >
                                                <Text style={[styles.tableCellItem, styles.row_data]}>
                                                    {itemlist?.D_Pcs}
                                                </Text>
                                            </View>

                                            <View
                                                style={[
                                                    styles.tableColItem,
                                                    styles.mrp,
                                                    styles.colBorder,
                                                ]}
                                            >
                                                <Text style={[styles.tableCellItem, styles.row_data]}>
                                                    {itemlist?.Rate || 0}
                                                </Text>
                                            </View>

                                            <View
                                                style={[
                                                    styles.tableColItem,
                                                    styles.amount,
                                                    styles.colBorder,
                                                ]}
                                            >
                                                <Text style={[styles.tableCellItem, styles.row_data, { textAlign: "right" }]}>
                                                    {itemlist?.Amount}
                                                </Text>
                                            </View>

                                            <View
                                                style={[
                                                    styles.tableColItem,
                                                    styles.discper,
                                                    styles.colBorder,
                                                ]}
                                            >
                                                <Text style={[styles.tableCellItem, styles.row_data]}>
                                                    {itemlist?.DiscPer}
                                                </Text>
                                            </View>

                                            <View
                                                style={[
                                                    styles.tableColItem,
                                                    styles.discamt,
                                                    styles.colBorder,
                                                ]}
                                            >
                                                <Text style={[styles.tableCellItem, styles.row_data, { textAlign: "right" }]}>
                                                    {itemlist?.DiscAmt}
                                                </Text>
                                            </View>

                                            <View
                                                style={[
                                                    styles.tableColItem,
                                                    styles.amount,
                                                    styles.colBorder,
                                                ]}
                                            >
                                                <Text style={[styles.tableCellItem, styles.row_data, { textAlign: "right", paddingRight: 5 }]}>
                                                    {Number(itemlist?.NetAmount || 0).toFixed(2)}
                                                </Text>
                                            </View>
                                        </View>
                                    );
                                })}
                            </View>


                        </div>

                        {/* itemFooter */}
                        {pageIndex === pages.length - 1 && (
                            <View>
                                <View style={[styles.table]}>
                                    <View style={[styles.tableRow]}>
                                        <View style={[styles.tableCol, styles.mainflexdiv,]}>
                                            <View style={[styles.table,]}>
                                                <View style={[styles.tableRow]}>
                                                    <View style={[styles.tableCol,]}>
                                                        <Text style={[styles.tableCell, styles.font_bold]}>Remark</Text>
                                                        <Text>{item?.Remark}</Text>
                                                    </View>


                                                </View>
                                               
                                            </View>
                                        </View>
                                        {/* new colu,mn */}
                                        <View style={[styles.tableCol, styles.mainflexdiv,]}>
                                            <View style={[styles.table,]}>
                                                <View style={[styles.tableRow, styles.dtotal]}>
                                                    <View style={[styles.tableCol,]}>
                                                        <Text style={[styles.tableCell, styles.font_bold, { textAlign: "center", fontSize: "10px" }]}>Total Invoice Amount </Text>
                                                    </View>
                                                    <View style={[styles.tableCol,]}>
                                                        <Text style={[styles.tableCell, styles.font_bold, { textAlign: "right", fontSize: "10px", marginRight: "5px" }]}>{totalAmt.toFixed(2)}</Text>
                                                    </View>
                                                </View>
                                                <View style={[styles.tableRow]}>
                                                    <View style={[styles.tableCol,]}>
                                                        <Text style={[styles.tableCell, styles.font_bold, { padding: "2px", }]}>T E R M S </Text>
                                                        <Text style={{ textAlign: "left", paddingTop: "5px" }}>Please send two copies of your invoice</Text>
                                                    </View>


                                                </View>
                                                 


                                            </View>
                                        </View>

                                    </View>
                                </View>

                                {/* End itemFooter  */}

                                {/* /End main */}
                                {/* footrer */}
                                <View style={[styles.table]}>
                                    <View style={[styles.tableRow]}>
                                        <View style={[styles.tableCol, styles.mainflexdiv,]}>
                                            <View style={[styles.table,]}>
                                                <View style={[styles.tableRow]}>
                                                    <View style={[styles.tableCol,]}>

                                                        <Text style={[styles.tableCell, styles.font_bold, { paddingTop: "33px" }]}>Receivers Signature ___________________________________</Text>

                                                    </View>


                                                </View>

                                            </View>
                                        </View>
                                        {/* new colu,mn */}
                                        <View style={[styles.tableCol, styles.mainflexdiv,]}>
                                            <View style={[styles.table,]}>
                                                <View style={[styles.tableRow]}>
                                                    <View style={[styles.tableCol,]}>
                                                        <Text style={[styles.tableCell, styles.font_bold, { textAlign: "center" }]}>{item?.SpAc_Desc}</Text>
                                                        
                                                    </View>
{/* {isdistributor ? item?.PAc_Desc : item?.compname} */}
                                                </View>
                                                <View style={[styles.tableRow]}>
                                                    <View style={[styles.tableCol,]}>

                                                        <Text style={[styles.tableCell, styles.font_bold, { textAlign: "center", paddingTop: "20px" }]}>Authorised by</Text>
                                                       
                                                        
                                                        

                                                    </View>


                                                </View>

                                            </View>
                                        </View>

                                    </View>
                                </View>
                                <View><Text style={[styles.tableCell, styles.font_bold,{textAlign:"right",paddingTop:"2px"}]}>Entry Date: {funGetDateTime(item?.Entry_Date)}</Text></View>
                            </View>
                        )}

                        {/* Add this immediately after the footer condition */}
                        {pageIndex < pages.length - 1 && (
                            <View
                                style={{
                                    position: "absolute",
                                    bottom: 8,
                                    right: 8,
                                }}
                            >
                                <Text
                                    style={{
                                        fontSize: 7,
                                        fontFamily: "Helvetica-Bold",
                                        textAlign: "right",
                                    }}
                                >
                                    TO BE CONTINUED...
                                </Text>
                            </View>
                        )}
                        {/* end footer */}
                    </View>



                </Page>
            ))}
        </Document>
    )
}
export default RptPurchaseOrder
